import { api, requestV1 } from 'apis/base'
import { SubscriptionPlanV1 } from 'apis/response_types'

export const listMeDoorPlans = async (doorId?: string) => {
  return api<SubscriptionPlanV1[]>({
    method: 'GET',
    url: `/me/door/subscription_plans`,
    params: {
      management_door_id: doorId
    }
  })
}

export const listDoorPlansV1 = async (id: string, options: { secret?: string } = {}) => {
  const { secret } = options
  let path = `/doors/${id}/subscription_plans`
  const searchParams = new URLSearchParams()
  if(secret) searchParams.append('secret', secret)


  // Line 0:  Parsing error: DeprecationError: 'originalKeywordKind' has been deprecated since v5.0.0 and can no longer be used. Use 'identifierToKeywordKind(identifier)' instead
  // 意味不明なエラーによる dev server 起動失敗の回避として @ts-ignore を記載
  // @ts-ignore
  if (Array.from(searchParams).length > 0) path = path + '?' + searchParams.toString()
  return await requestV1<SubscriptionPlanV1[]>('GET', path)
}

export const listRoomPlansV1 = async (roomId: string) => {
  const path = `/rooms/${roomId}/subscription_plans`
  return await requestV1<SubscriptionPlanV1[]>('GET', path)
}


export const doorPlanV1 = async (
  id: string,
  plan_id: string,
  secret?: string
) => {
  let path = `/doors/${id}/subscription_plans/${plan_id}`
  if (secret) {
    path = path + `?secret=${secret}`
  }
  return await requestV1<SubscriptionPlanV1>('GET', path)
}

export const getMeDoorPlan = async (id: number, doorId?: string) => {
  return api<SubscriptionPlanV1>({
    method: 'GET',
    url: `/me/door/subscription_plans/${id}`,
    params: {
      management_door_id: doorId
    }
  })
}

export const deletePlan = async (id: number, doorId?: string) => {
  return api<{}>({
    method: 'DELETE',
    url: `/me/door/subscription_plans/${id}`,
    params: {
      management_door_id: doorId
    }
  })
}

export const sortMeDoorPlans = async (
  planIdsSeq: number[],
  doorId?: string
) => {
  return api<null>({
    method: 'PATCH',
    url: `/me/door/subscription_plans/sorting`,
    data: {
      plan_ids: planIdsSeq,
      door_id: doorId
    }
  })
}

export type CreateSubscriptionPlanRequest = {
  title: string
  description: string
  subscription_cost: number
  is_suspended: Boolean
  capacity?: number
  is_display_capacity: Boolean
  is_display_member_count: Boolean
  free_trial_period?: number
  thumnail_image?: File
  delete_thumbnail?: Boolean
  rooms: number[]
  secret_id: string | undefined
  invisible: Boolean
  recurring: boolean
  payment_interval_months: number
  joinable_starts_at?: string
  joinable_months?: number
  available_days_after_joinable?: number
}

export type UpdateSubscriptionPlanRequest = CreateSubscriptionPlanRequest & {
  limited_modify_reason?: string
  limited_modify_other?: string
}

export interface AbortSubscriptionPlanRequest {
  invisible: Boolean
  limitedAbortReason: string
  limitedAbortOther: string
}

export const createSubscriptionPlan = async (
  request: CreateSubscriptionPlanRequest,
  doorId?: string
) => {
  const formData = new FormData()
  formData.append('title', request.title)
  formData.append('description', request.description)
  formData.append('is_suspended', request.is_suspended.toString())
  formData.append('is_display_member_count', request.is_display_member_count.toString())
  formData.append('subscription_cost', request.subscription_cost.toString())
  formData.append('invisible', request.invisible.toString())
  formData.append('recurring', request.recurring.toString())
  formData.append(
    'payment_interval_months',
    request.payment_interval_months.toString()
  )
  if (request.joinable_starts_at)
    formData.append('joinable_starts_at', request.joinable_starts_at)
  if (request.joinable_months)
    formData.append('joinable_months', request.joinable_months.toString())
  if (request.available_days_after_joinable)
    formData.append(
      'available_days_after_joinable',
      request.available_days_after_joinable.toString()
    )
  if (request.secret_id) formData.append('secret_id', request.secret_id)
  request.rooms.forEach((val) => {
    formData.append(`rooms[]`, val.toString())
  })
  request.capacity !== undefined &&
    formData.append('capacity', request.capacity.toString())
  formData.append('is_display_capacity', request.is_display_capacity.toString())

  request.free_trial_period !== undefined &&
    formData.append('free_trial_period', request.free_trial_period.toString())
  request.thumnail_image !== undefined &&
    formData.append('thumnail_image', request.thumnail_image)
  if (doorId !== undefined) formData.append('management_door_id', doorId)
  return api<{}>({
    method: 'POST',
    url: `/me/door/subscription_plans`,
    data: formData
  })
}

export const updateSubscriptionPlan = async (
  id: number,
  request: UpdateSubscriptionPlanRequest,
  doorId?: string
) => {
  const formData = new FormData()
  formData.append('title', request.title)
  formData.append('description', request.description)
  formData.append('is_suspended', request.is_suspended.toString())
  formData.append('is_display_member_count', request.is_display_member_count.toString())
  formData.append('subscription_cost', request.subscription_cost.toString())
  formData.append('invisible', request.invisible.toString())
  formData.append('recurring', request.recurring.toString())
  formData.append(
    'payment_interval_months',
    request.payment_interval_months.toString()
  )
  request.rooms.forEach((val) => {
    formData.append(`rooms[]`, val.toString())
  })
  if (request.limited_modify_reason)
    formData.append('limited_modify_reason', request.limited_modify_reason)
  if (request.limited_modify_other)
    formData.append('limited_modify_other', request.limited_modify_other)
  if (request.joinable_starts_at)
    formData.append('joinable_starts_at', request.joinable_starts_at)
  if (request.joinable_months)
    formData.append('joinable_months', request.joinable_months.toString())
  if (request.available_days_after_joinable)
    formData.append(
      'available_days_after_joinable',
      request.available_days_after_joinable.toString()
    )
  if (request.secret_id) formData.append('secret_id', request.secret_id)
  request.capacity !== undefined &&
    formData.append('capacity', request.capacity.toString())
  request.is_display_capacity !== undefined &&
    formData.append(
      'is_display_capacity',
      request.is_display_capacity.toString()
    )
  request.free_trial_period !== undefined &&
    formData.append('free_trial_period', request.free_trial_period.toString())
  request.thumnail_image !== undefined &&
    formData.append('thumnail_image', request.thumnail_image)
  request.delete_thumbnail && formData.append('delete_thumbnail', 'true')
  if (doorId !== undefined) formData.append('management_door_id', doorId)
  return api<{}>({
    method: 'PATCH',
    url: `/me/door/subscription_plans/${id}`,
    data: formData
  })
}

export const abortSubscriptionPlan = async (
  id: number,
  request: AbortSubscriptionPlanRequest,
  doorId?: string
) => {
  const formData = new FormData()
  formData.append('invisible', request.invisible.toString())
  formData.append('limited_abort_reason', request.limitedAbortReason)
  if (request.limitedAbortOther)
    formData.append('limited_abort_other', request.limitedAbortOther)
  if (doorId !== undefined) formData.append('management_door_id', doorId)
  return api<{}>({
    method: 'PATCH',
    url: `/me/door/subscription_plans/${id}/abort`,
    data: formData
  })
}
